import { render, staticRenderFns } from "./business-type.vue?vue&type=template&id=35de7e64&scoped=true&"
import script from "./business-type.vue?vue&type=script&lang=js&"
export * from "./business-type.vue?vue&type=script&lang=js&"
import style0 from "./business-type.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./business-type.vue?vue&type=style&index=1&id=35de7e64&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de7e64",
  null
  
)

export default component.exports